import { RequirementDto } from '../queries/usePasswordRequirementsQuery/types';

export const newPasswordIsValid = (
  newPassword: string,
  requirementsLookup?: RequirementDto[]
) => {
  let valid = true;

  if (!requirementsLookup) {
    return valid;
  }

  requirementsLookup.forEach((requirement) => {
    switch (requirement.lookup_code) {
      case 'password_length':
        valid = newPassword.length >= 8;
        break;
      case 'alphanumeric':
        valid = /[a-zA-Z]/.test(newPassword) && /\d/.test(newPassword);
        break;
      case 'uppercase':
        valid = /[A-Z]/.test(newPassword);
        break;
      case 'lowercase':
        valid = /[a-z]/.test(newPassword);
        break;
      case 'special_character':
        valid = /[^a-zA-Z0-9]/.test(newPassword);
        break;
    }
  });
  return valid;
};
